import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import isErrorAction from "common/api/utils/isErrorAction";
import isForbiddenErrorAction from "common/api/utils/isForbiddenErrorAction";
import isNotFoundErrorAction from "common/api/utils/isNotFoundErrorAction";
import isUnauthenticatedErrorAction from "common/api/utils/isUnauthenticatedErrorAction";

type MessagesState = {
  lastErrors: Error[];
};
const maxErrors = 4;

const initialState: MessagesState = {
  lastErrors: [],
};

export const messagesSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    removeError: (state, action: PayloadAction<{ index: number }>) => {
      const { index } = action.payload;
      if (index >= state.lastErrors.length) return;
      state.lastErrors.splice(index, 1);
    },
    addError: (state, action: PayloadAction<{ message: string }>) => {
      const { message } = action.payload;
      const error = new Error(message);
      state.lastErrors.unshift(error);
      if (state.lastErrors.length === maxErrors) {
        state.lastErrors.pop();
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) =>
        isErrorAction(action) &&
        !isUnauthenticatedErrorAction(action) &&
        !isForbiddenErrorAction(action) &&
        !isNotFoundErrorAction(action),
      (state, action) => {
        const { error } = action;
        state.lastErrors.unshift(error);
        if (state.lastErrors.length === maxErrors) {
          state.lastErrors.pop();
        }
      }
    );
  },
});

export const { removeError, addError } = messagesSlice.actions;
